import { orderTransactionTypes } from '@/constants'

export const isExchangeOrMixedWithPayment = (orderTransactionType, exchangedForOrder) => {
  return (
    [orderTransactionTypes.exchange, orderTransactionTypes.mixed].includes(orderTransactionType) &&
    exchangedForOrder?.needs_payment &&
    exchangedForOrder?.checkout_url != null
  )
}

export const isExchangeOrMixedWithoutPayment = (orderTransactionType, exchangedForOrder) => {
  return (
    [orderTransactionTypes.exchange, orderTransactionTypes.mixed].includes(orderTransactionType) &&
    exchangedForOrder?.needs_payment &&
    !exchangedForOrder?.checkout_url
  )
}
